import React from 'react'

const FuelBox = ({fueldata, unit}) => {
    return (
        <div className="bg-secondary sm:w-full md:w-80 p-4 mb-2">
            {/* <h3 className="flex text-base font-bold px-3 py-3 justify-center mb-2">
                Fuel Information
            </h3> */}
            <ul className="space-y-2">
                <li className="flex justify-between border border-bordercolor3 px-2 py-1 hover:border-white transform transition-colors duration-200">
                    <h5 className="text-bordercolor2 font-semibold text-lg">Taxi</h5>
                    <span className="font-semibold text-lg">{fueldata.taxi} {unit}</span>
                </li>
                <li className="flex justify-between border border-bordercolor3 px-2 py-1 hover:border-white transform transition-colors duration-200">
                    <h5 className="text-bordercolor2 font-semibold text-lg">TRIP</h5>
                    <span className="font-semibold text-lg">{fueldata.enroute_burn} {unit}</span>
                </li>
                <li className="flex justify-between border border-bordercolor3 px-2 py-1 hover:border-white transform transition-colors duration-200">
                    <h5 className="text-bordercolor2 font-semibold text-lg">CONT 15 MIN</h5>
                    <span className="font-semibold text-lg">{fueldata.contingency} {unit}</span>
                </li>
                <li className="flex justify-between border border-bordercolor3 px-2 py-1 hover:border-white transform transition-colors duration-200">
                    <h5 className="text-bordercolor2 font-semibold text-lg">ALTN</h5>
                    <span className="font-semibold text-lg">{fueldata.alternate_burn} {unit}</span>
                </li>
                <li className="flex justify-between border border-bordercolor3 px-2 py-1 hover:border-white transform transition-colors duration-200">
                    <h5 className="text-bordercolor2 font-semibold text-lg">RESERVES</h5>
                    <span className="font-semibold text-lg">{fueldata.reserve} {unit}</span>
                </li>
                <li className="flex justify-between border border-bordercolor3 px-2 py-1 hover:border-white transform transition-colors duration-200">
                    <h5 className="text-bordercolor2 font-semibold text-lg">BLOCK</h5>
                    <span className="font-semibold text-lg">{fueldata.plan_ramp} {unit}</span>
                </li>
                <li className="flex justify-between border border-bordercolor3 px-2 py-1 hover:border-white transform transition-colors duration-200">
                    <h5 className="text-bordercolor2 font-semibold text-lg">EXTRA</h5>
                    <span className="font-semibold text-lg">{fueldata.extra} {unit}</span>
                </li>
            </ul>
        </div>
    )
}

export default FuelBox
